import React from 'react';
import { formatWhatsAppMarkdownHtml } from '../../utils';

/**
 * WhatsApp chat-bubble preview - single source for the "tan background, white bubble, bottom-right
 * timestamp" look used on WhatsApp > Templates (create/edit) so every place that shows a WhatsApp
 * template preview (that page, the Automation builder's WhatsApp node, anywhere else later) renders
 * the exact same visual instead of each screen re-building its own version.
 * `headerNode` - optional custom JSX rendered above the body (image/video/document/location/plain
 * text header - WhatsApp > Templates already builds this JSX itself and just passes it through).
 * `bodyText` / `footerText` - plain template text; same markdown formatting as before.
 */
export default function WhatsAppMessagePreview({ bodyText, footerText, headerNode, belowBubbleNode, label = 'Preview' }) {
    return (
        <div>
            {label ? <div className="small fw-semibold mb-2 text-muted">{label}</div> : null}
            <div
                style={{
                    background: '#e5ddd5',
                    borderRadius: 12,
                    padding: 16,
                    minHeight: 80,
                    backgroundImage: 'linear-gradient(rgba(229,221,213,.92), rgba(229,221,213,.92))',
                }}
            >
                <div
                    style={{
                        background: '#fff',
                        borderRadius: '8px 8px 8px 8px',
                        maxWidth: '92%',
                        boxShadow: '0 1px 1px rgba(0,0,0,.12)',
                    }}
                >
                    {headerNode}
                    {bodyText ? (
                        <div
                            className="wa-md"
                            style={{ whiteSpace: 'pre-wrap', fontSize: 14, padding: 8 }}
                            dangerouslySetInnerHTML={{ __html: formatWhatsAppMarkdownHtml(bodyText) }}
                        />
                    ) : (
                        <div style={{ whiteSpace: 'pre-wrap', fontSize: 14, padding: 8 }}>
                            <span className="text-muted">Type the body to see the preview…</span>
                        </div>
                    )}
                    {footerText ? (
                        <div className="text-muted mt-1" style={{ fontSize: 12, padding: 8 }}>
                            {footerText}
                        </div>
                    ) : null}
                    <div className="text-end text-muted" style={{ fontSize: 11, marginTop: 4, padding: 8 }}>
                        {new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                    </div>
                </div>
                {belowBubbleNode}
            </div>
        </div>
    );
}
